'use client'

import React, { useEffect, useState } from 'react'
import EventSlider from './EventSlider'
import { EventBannerResponse, PromotionBannerResponse, SubPromotionBanner } from '@/services/dataTypes'

interface Props {
    domain: string
    banners: EventBannerResponse[] | PromotionBannerResponse[] | SubPromotionBanner[]
    eventName: string
}

const EventBanner = ({ domain, banners, eventName }: Props) => {
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    if (!mounted || !banners?.length) return null

    return (
        <div className="relative overflow-hidden mx-2 md:mx-4 xl:mx-6 mt-2 md:mt-4 rounded-2xl border border-slate-200 shadow-sm">
            <EventSlider sliders={banners} domain={domain} eventName={eventName} />
        </div>
    )
}

export default EventBanner
